import { getAccessToken } from "./jwt-token-access/accessToken"

const API_BASE = process.env.REACT_APP_API_INT_LEADS || ""

function authHeaders() {
  return {
    "x-access-token": getAccessToken(),
    "Content-Type": "application/json",
  }
}

async function request(method, path, body, signal) {
  const options = { method, headers: authHeaders(), signal }
  if (body !== undefined) options.body = JSON.stringify(body)
  const res = await fetch(`${API_BASE}${path}`, options)
  if (!res.ok) {
    const text = await res.text().catch(() => "")
    throw new Error(`Azure DevOps proxy falhou: HTTP ${res.status} ${text}`)
  }
  return res.json()
}

export async function listPipelineRuns({ pipelineId, top = 20, signal } = {}) {
  if (!pipelineId) throw new Error("Parâmetros inválidos para listPipelineRuns")
  const params = top ? `?%24top=${encodeURIComponent(top)}` : ""
  return request("GET", `/api/azdo/pipelines/${encodeURIComponent(pipelineId)}/runs${params}`, undefined, signal)
}

export async function runPipeline({ pipelineId, resources = {}, templateParameters = {}, signal } = {}) {
  if (!pipelineId) throw new Error("Parâmetros inválidos para runPipeline")
  const body = {}
  if (resources && Object.keys(resources).length) body.resources = resources
  if (templateParameters && Object.keys(templateParameters).length) body.templateParameters = templateParameters
  return request("POST", `/api/azdo/pipelines/${encodeURIComponent(pipelineId)}/runs`, body, signal)
}

export async function getTotalFetchedFromBuildLogs({ buildId, signal } = {}) {
  if (!buildId) return null
  try {
    const data = await request("GET", `/api/azdo/builds/${encodeURIComponent(buildId)}/logs/total-fetched`, undefined, signal)
    return data && data.totalFetched != null ? data.totalFetched : null
  } catch {
    return null
  }
}

export function extractBuildIdFromWebLink(webUrl) {
  try {
    if (!webUrl) return ""
    const url = new URL(webUrl)
    return url.searchParams.get("buildId") || ""
  } catch {
    return ""
  }
}
